import React, { useState } from "react"
import Navbar from "../../components/Navbar/Navbar"
import Title from "antd/es/typography/Title"
import { useNavigate } from "react-router-dom"
import {
  Button,
  Card,
  Divider,
  Space,
  Statistic,
  Carousel,
  Modal,
  Collapse,
  Row,
  Col,
} from "antd"
import { CalendarOutlined } from "@ant-design/icons"
import moment from "moment"
import { globalStyles } from "../../utils/theme"
import "../../cssFiles/CustomStyles/Dashboard.css"
import { formatDate, getLocalData } from "../../utils/Common"
import { UseGetRequest, UsePostRequest } from "../../utils/api/ApiRequests"
import { getIsAdminLogin, getEmployeeId } from "../../utils/Common"

// const {RangePicker} = DatePicker;
const { Panel } = Collapse
export default function Dashboard() {
  let navigate = useNavigate()
  // const dateToday = new Date();
  const isAdminLogin = getIsAdminLogin()
  const employeeId = getEmployeeId()
  const [date, setDate] = useState(new Date())
  const [user, setUser] = useState("")
  const [filterConfig, setFilterConfig] = useState({
    // date_from: moment().format('YYYY-MM-DD'),
    // date_to: moment().format('YYYY-MM-DD'),
    employee_id: isAdminLogin ? null : employeeId,
  })

  const [recentActivities, setRecentActivities] = useState([])
  const [birthdays, setBirthdays] = useState([])
  const [anniversaries, setAnniversaries] = useState([])
  const [announcements, setAnnouncements] = useState([])
  const [memos, setMemos] = useState([])
  const [requirements, setRequirements] = useState([])
  const [lackingEmployees, setLackingEmployees] = useState([])
  const [showLackingModal, setShowLackingModal] = useState(false)
  const [companyFiles, setCompanyFiles] = useState([])
  // const [countData, setCountData] = useState({});
  // const [showCountModal, setShowCountModal] = useState(false);
  // const [countModalData, setCountModalData] = useState({title: '', employees: []});
  const [employmentStatus, setEmploymentStatus] = useState([])
  const [employeeStatus, setEmployeeStatus] = useState([])

  const formattedDate = date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  })

  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  })

  function transformControllerName(name) {
    if (name && name.includes("_")) {
      return name
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    } else {
      return name.charAt(0).toUpperCase() + name.slice(1)
    }
  }

  // function handleModalClick (title, modalData) {
  //   setCountModalData({title: title, employees: modalData});
  //   setShowCountModal(true);
  // }

  // const handleDateFilter = (e) => {
  //   if (e) {
  //       setFilterConfig((prev) => ({...prev,
  //           date_from: e[0].format('YYYY-MM-DD'),
  //           date_to: e[1].format('YYYY-MM-DD'),
  //       }));
  //   }
  // }

  React.useEffect(() => {
    const timer = setInterval(() => {
      setDate(new Date())
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  React.useEffect(() => {
    async function getName() {
      const res = await getLocalData("name")
      setUser(res)
    }
    getName()
  }, [])

  React.useEffect(() => {
    async function fetchRecentActivities() {
      setRecentActivities([])
      const response = await UsePostRequest(
        "users/get_recent_activities",
        filterConfig
      )
      if (response && response.data && Array.isArray(response.data)) {
        const tempData = response.data.map((row) => {
          var info = {}
          info.date = moment(row.responded_on).format("MMMM DD, YYYY")
          var controller = transformControllerName(row.controller)
          if (row.method === "add") {
            info.action = `Added ${controller}`
          } else if (row.method === "update") {
            info.action = `Updated ${controller}`
          } else if (row.method === "delete") {
            info.action = `Deleted ${controller}`
          } else {
            info.action = `${row.method} ${controller}`
          }
          return info
        })
        setRecentActivities(tempData)
      } else {
        setRecentActivities([])
      }
    }

    async function fetchBirthdaysAndAnniversaries() {
      const response = await UsePostRequest("employees/get_all", {})
      if (response && response.data && Array.isArray(response.data)) {
        const currentDate = new Date()

        const upcomingBirthdays = response.data.filter((employee) => {
          const birthdate = new Date(employee.birthdate)
          const nextBirthday = new Date(
            currentDate.getFullYear(),
            birthdate.getMonth(),
            birthdate.getDate()
          )

          return (
            nextBirthday >= currentDate &&
            nextBirthday <=
              new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate() + 7
              )
          )
        })

        const upcomingAnniversaries = response.data.filter((employee) => {
          const dateHired = new Date(employee.date_hired)
          const nextAnniv = new Date(
            currentDate.getFullYear(),
            dateHired.getMonth(),
            dateHired.getDate()
          )

          return (
            nextAnniv >= currentDate &&
            nextAnniv <=
              new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate() + 7
              )
          )
        })
        setBirthdays(upcomingBirthdays)
        setAnniversaries(upcomingAnniversaries)
      } else {
        setBirthdays([])
        setAnniversaries([])
      }
    }

    async function fetchAnnouncementsAndMemos() {
      const announecements = await UseGetRequest("announcements/get")
      if (announecements && announecements.data) {
        const rawAnnouncements =
          announecements.data.announcements ||
          announecements.data.data?.announcements ||
          (Array.isArray(announecements.data) ? announecements.data : [])
        setAnnouncements(Array.isArray(rawAnnouncements) ? rawAnnouncements : [])
      } else {
        setAnnouncements([])
      }

      const memos = await UseGetRequest("memos/get")
      if (memos && memos.data) {
        const rawMemos =
          memos.data.memos ||
          memos.data.data?.memos ||
          (Array.isArray(memos.data) ? memos.data : [])
        setMemos(Array.isArray(rawMemos) ? rawMemos : [])
      } else {
        setMemos([])
      }
    }

    async function fetchCompanyFiles() {
      const tempCompanyFiles = await UseGetRequest("companies/get_all")
      if (tempCompanyFiles && tempCompanyFiles.data) {
        const rawCompanyFiles =
          tempCompanyFiles.data.company ||
          tempCompanyFiles.data.data?.company ||
          (Array.isArray(tempCompanyFiles.data) ? tempCompanyFiles.data : [])
        setCompanyFiles(Array.isArray(rawCompanyFiles) ? rawCompanyFiles : [])
      } else {
        setCompanyFiles([])
      }
    }

    async function fetchOtherData() {
      const tempRequirements = await UseGetRequest(
        "dashboard/get_requirement_lacking_count"
      )
      if (tempRequirements && tempRequirements.data) {
        const rawRequirements =
          tempRequirements.data.reports ||
          tempRequirements.data.data?.reports ||
          (Array.isArray(tempRequirements.data) ? tempRequirements.data : [])
        setRequirements(Array.isArray(rawRequirements) ? rawRequirements : [])
      } else {
        setRequirements([])
      }

      const tempEmploymentStatus = await UseGetRequest(
        "dashboard/get_employment_status_report"
      )
      if (tempEmploymentStatus && tempEmploymentStatus.data) {
        const rawEmploymentStatus =
          tempEmploymentStatus.data.reports ||
          tempEmploymentStatus.data.data?.reports ||
          (Array.isArray(tempEmploymentStatus.data) ? tempEmploymentStatus.data : [])
        setEmploymentStatus(
          Array.isArray(rawEmploymentStatus) ? rawEmploymentStatus : []
        )
      } else {
        setEmploymentStatus([])
      }

      const tempEmployeeStatus = await UseGetRequest(
        "dashboard/get_employee_status_report"
      )
      if (tempEmployeeStatus && tempEmployeeStatus.data) {
        const rawEmployeeStatus =
          tempEmployeeStatus.data.reports ||
          tempEmployeeStatus.data.data?.reports ||
          (Array.isArray(tempEmployeeStatus.data) ? tempEmployeeStatus.data : [])
        setEmployeeStatus(
          Array.isArray(rawEmployeeStatus) ? rawEmployeeStatus : []
        )
      } else {
        setEmployeeStatus([])
      }
    }

    fetchRecentActivities()
    fetchBirthdaysAndAnniversaries()
    fetchAnnouncementsAndMemos()
    fetchCompanyFiles()

    if (isAdminLogin) {
      fetchOtherData()
    }
  }, [])

  // React.useEffect(() => {
  //   async function fetchCounts() {
  //     setCountData({})
  //     const response = await UsePostRequest("dashboard/get_counts", filterConfig);
  //     if (response.response) {
  //       setCountData(response.response);
  //     }
  //   }

  //   fetchCounts();
  // }, [filterConfig])

  return (
    <Navbar>
      <Space className="d-flex justify-content-between p-3" wrap>
        <Title level={3}>Hello, {user}! 👋🏻</Title>
        <Title
          level={4}
          className="pointer-cursor calendar-button"
          onClick={() => navigate("eventscalendar")}
        >
          <CalendarOutlined className="me-2" /> {formattedDate}, {formattedTime}
        </Title>
      </Space>

      <Row className="p-3">
        <Col className="p-1" xs={24} lg={8}>
          <Card className="shadow" style={{ height: "50vh", paddingRight: 0 }}>
            <Row className="m-o p-0 d-flex align-items-center justify-content-between">
              <Col>
                <Title level={5}>Recent Activies</Title>
              </Col>
              {/* <Col style={{textAlign: 'right'}}><Button type='text' onClick={()=>navigate("/orders")}>View all</Button></Col> */}
            </Row>
            <Divider className="" />
            <Row
              style={{ height: "30vh", overflow: "auto", overflowX: "hidden" }}
            >
              {Array.isArray(recentActivities) &&
                recentActivities.map((order, index) => {
                  return (
                    <Card
                      key={index}
                      className="mt-1 w-100"
                      bodyStyle={{ padding: 10 }}
                      hoverable
                    >
                      <Row>
                        <Col className="">
                          <Row>
                            <Col className="fw-bold small-text">
                              {order.action}
                            </Col>
                          </Row>
                          <Row>
                            <Col className="small-text text-muted">
                              {order.date}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Card>
                  )
                })}
            </Row>
          </Card>
        </Col>
        <Col className="p-1" xs={24} lg={8}>
          <Card className="shadow" style={{ height: "50vh", paddingRight: 0 }}>
            <Row className="m-o p-0 d-flex align-items-center justify-content-between">
              <Col>
                <Title level={5}>Birthdays</Title>
              </Col>
              {/* <Col style={{textAlign: 'right'}}><Button type='text' onClick={()=>navigate("/orders")}>View all</Button></Col> */}
            </Row>
            <Divider />
            <Row
              style={{ height: "30vh", overflow: "auto", overflowX: "hidden" }}
            >
              {(!birthdays || birthdays.length === 0) && (
                <Card className="gray text-center center w-100">
                  NO UPCOMING BIRTHDAYS
                </Card>
              )}
              {Array.isArray(birthdays) &&
                birthdays.length > 0 &&
                birthdays.map((row, index) => {
                  return (
                    <Card
                      key={index}
                      className="m-1 mt-0 w-100"
                      bodyStyle={{ padding: 10 }}
                      hoverable
                    >
                      <Row>
                        <Col className="col-10">
                          <Row>
                            <Col className="fw-bold small-text">
                              {`${row.first_name} ${row.middle_name} ${row.last_name}`}
                            </Col>
                          </Row>
                          <Row>
                            <Col className="small-text text-muted">
                              {row.birthdate ? formatDate(row.birthdate) : ""}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Card>
                  )
                })}
            </Row>
          </Card>
        </Col>
        <Col className="p-1" xs={24} lg={8}>
          <Card className="shadow" style={{ height: "50vh", paddingRight: 0 }}>
            <Row className="m-o p-0 d-flex align-items-center justify-content-between">
              <Col>
                <Title level={5}>Anniversaries</Title>
              </Col>
            </Row>
            <Divider />
            <Row
              style={{ height: "30vh", overflow: "auto", overflowX: "hidden" }}
            >
              {(!anniversaries || anniversaries.length === 0) && (
                <Card className="gray text-center center w-100">
                  NO UPCOMING ANNIVERSARIES
                </Card>
              )}
              {Array.isArray(anniversaries) &&
                anniversaries.length > 0 &&
                anniversaries.map((row, index) => {
                  return (
                    <Card
                      key={index}
                      className="m-1 mt-0 w-100"
                      bodyStyle={{ padding: 10 }}
                      hoverable
                    >
                      <Row>
                        <Col className="col-10">
                          <Row>
                            <Col className="fw-bold small-text">
                              {`${row.first_name} ${row.middle_name} ${row.last_name}`}
                            </Col>
                          </Row>
                          <Row>
                            <Col className="small-text text-muted">
                              {row.date_hired ? formatDate(row.date_hired) : ""}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Card>
                  )
                })}
            </Row>
          </Card>
        </Col>
      </Row>

      <Row className="p-3">
        <Col className="p-1" xs={24} lg={12}>
          <Card
            className="shadow carousel-card"
            style={{ height: "50vh", paddingRight: 0, overflowY: "scroll" }}
          >
            <Row className="m-o p-0 d-flex align-items-center justify-content-between">
              <Col>
                <Title level={5}>Announcements</Title>
              </Col>
              <Col style={{ textAlign: "right" }}>
                <Button type="text" onClick={() => navigate("/announcements")}>
                  View all
                </Button>
              </Col>
            </Row>
            <Divider />
            <Carousel autoplay>
              {Array.isArray(announcements) && announcements.length > 0 ? (
                announcements.map((data, index) => {
                  return (
                    <div key={index} className="px-3">
                      <Row className="d-flex justify-content-between carousel-header">
                        <Col className="welcome-msg">
                          {data.subject ? data.subject : ""}
                        </Col>
                        <Col className="text-end">
                          {data.announcement_date
                            ? formatDate(data.announcement_date)
                            : ""}
                        </Col>
                      </Row>
                      <Row>
                        <div
                          dangerouslySetInnerHTML={{ __html: data.content }}
                          className="p-3 carousel-content"
                        />
                      </Row>
                    </div>
                  )
                })
              ) : (
                <div className="p-4 text-center text-muted">
                  No announcements available
                </div>
              )}
            </Carousel>
          </Card>
        </Col>
        <Col className="p-1" xs={24} lg={12}>
          <Card
            className="shadow carousel-card"
            style={{ height: "50vh", paddingRight: 0, overflowY: "scroll" }}
          >
            <Row className="m-o p-0 d-flex align-items-center justify-content-between">
              <Col>
                <Title level={5}>Memorandum</Title>
              </Col>
              <Col style={{ textAlign: "right" }}>
                <Button type="text" onClick={() => navigate("/memorandums")}>
                  View all
                </Button>
              </Col>
            </Row>
            <Divider />
            <Carousel autoplay>
              {Array.isArray(memos) && memos.length > 0 ? (
                memos.map((data, index) => {
                  return (
                    <div key={index} className="px-3">
                      <Row className="d-flex justify-content-between carousel-header">
                        <Col className="welcome-msg">
                          {data.subject ? data.subject : ""}
                        </Col>
                        <Col className="text-end">
                          {data.announcement_date
                            ? formatDate(data.announcement_date)
                            : ""}
                        </Col>
                      </Row>
                      <Row>
                        <div
                          dangerouslySetInnerHTML={{ __html: data.content }}
                          className="p-3 carousel-content"
                        />
                      </Row>
                    </div>
                  )
                })
              ) : (
                <div className="p-4 text-center text-muted">
                  No memorandums available
                </div>
              )}
            </Carousel>
          </Card>
        </Col>
      </Row>

      <Row className="p-3">
        {isAdminLogin && (
          <Col className="p-1" xs={24} lg={12}>
            <Card
              className="shadow"
              style={{ height: "50vh", paddingRight: 0 }}
            >
              <Row className="m-o p-0 d-flex align-items-center justify-content-between">
                <Col>
                  <Title level={5}>Lacking Requirements</Title>
                </Col>
                <Col style={{ textAlign: "right" }}>
                  <Button type="text" onClick={() => navigate("/requirements")}>
                    View all
                  </Button>
                </Col>
              </Row>
              <Divider />
              <Row className="">
                {Array.isArray(requirements) &&
                  requirements.map((data, index) => (
                    <Col
                      key={index}
                      xs={12}
                      md={6}
                      className="p-1"
                      onClick={() => {
                        setLackingEmployees(
                          Array.isArray(data.employees) ? data.employees : []
                        )
                        setShowLackingModal(true)
                      }}
                    >
                      <Card bordered className="custom-card pointer-cursor">
                        <Statistic
                          title={data.status}
                          value={data.count}
                          valueStyle={{
                            color: globalStyles.colorPrimary,
                          }}
                          style={{ height: 70 }}
                        />
                      </Card>
                    </Col>
                  ))}
              </Row>
            </Card>
          </Col>
        )}
        <Col className="p-1" xs={24} lg={12}>
          <Card
            className="shadow carousel-card"
            style={{ height: "50vh", paddingRight: 0 }}
          >
            <Row className="m-o p-0 d-flex align-items-center justify-content-between">
              <Col>
                <Title level={5}>Company Files</Title>
              </Col>
            </Row>
            <Divider />
            <Collapse accordion>
              {Array.isArray(companyFiles) &&
                companyFiles.map((data, index) => (
                  <Panel header={data.name} key={index}>
                    {data?.company_files &&
                      Array.isArray(data.company_files) &&
                      data.company_files.map((file, fIndex) => (
                        <Row key={fIndex} className="ms-3">{`${fIndex + 1}. ${
                          file.file_name
                        }`}</Row>
                      ))}
                  </Panel>
                ))}
            </Collapse>
          </Card>
        </Col>
      </Row>

      {isAdminLogin && (
        <Row className="p-3">
          <Col className="p-1" xs={24} lg={12}>
            <Card
              className="shadow"
              style={{ height: "50vh", paddingRight: 0 }}
            >
              <Row className="m-o p-0 d-flex align-items-center justify-content-between">
                <Col>
                  <Title level={5}>Employment Status</Title>
                </Col>
                <Col style={{ textAlign: "right" }}>
                  <Button type="text">View all</Button>
                </Col>
              </Row>
              <Divider />
              <Row className="">
                {Array.isArray(employmentStatus) &&
                  employmentStatus.map((data, index) => (
                    <Col key={index} xs={12} md={6} className="p-1">
                      <Card bordered className="custom-card">
                        <Statistic
                          title={data.name}
                          value={data.count}
                          valueStyle={{
                            color: globalStyles.colorPrimary,
                          }}
                          style={{ height: 70 }}
                        />
                      </Card>
                    </Col>
                  ))}
              </Row>
            </Card>
          </Col>

          <Col className="p-1" xs={24} lg={12}>
            <Card
              className="shadow"
              style={{ height: "50vh", paddingRight: 0 }}
            >
              <Row className="m-o p-0 d-flex align-items-center justify-content-between">
                <Col>
                  <Title level={5}>Employee Status</Title>
                </Col>
                <Col style={{ textAlign: "right" }}>
                  <Button type="text">View all</Button>
                </Col>
              </Row>
              <Divider />
              <Row className="">
                {Array.isArray(employeeStatus) &&
                  employeeStatus.map((data, index) => (
                    <Col key={index} xs={12} md={6} className="p-1">
                      <Card bordered className="custom-card">
                        <Statistic
                          title={data.name}
                          value={data.count}
                          valueStyle={{
                            color: globalStyles.colorPrimary,
                          }}
                          style={{ height: 70 }}
                        />
                      </Card>
                    </Col>
                  ))}
              </Row>
            </Card>
          </Col>
        </Row>
      )}

      <Modal
        open={showLackingModal}
        onCancel={() => setShowLackingModal(false)}
        onOk={() => setShowLackingModal(false)}
      >
        <Title level={5}>Peding Requirements</Title>
        <Divider />
        {Array.isArray(lackingEmployees) &&
          lackingEmployees.map((row, index) => {
            return (
              <Card
                key={index}
                className="m-1 mt-0"
                bodyStyle={{ padding: 10 }}
                hoverable
              >
                <Row>
                  <Col className="col-10">
                    <Row>
                      <Col className="fw-bold small-text">{row}</Col>
                    </Row>
                  </Col>
                </Row>
              </Card>
            )
          })}
      </Modal>
    </Navbar>
  )
}
